export default __webpack_public_path__ + "static/media/tentorium-dark.1f5a9426.png";